// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.intention.RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction } from '@zg-rentals/ts-rental-manager-api-client';

import type { UnifiedLeadInsertIntentionActionRequestWebDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Args {
  postData: UnifiedLeadInsertIntentionActionRequestWebDto;
}

export type RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Args
>;

/**
 * No-op; landlord intention is no longer recorded
 */
export const useRentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction_Args) =>
      RentalManagerUserUnifiedLeadInsertIntentionActionWebApiHandler_insertAction(args.postData, httpClient),
  });
};
